import type { Character, FilmInfoItem } from "@/types";

export const filmInfo: FilmInfoItem[] = [
  { label: "片名", value: "激情丛林" },
  { label: "英文片名", value: "Passion Jungle" },
  { label: "导演", value: "陆云舟" },
  { label: "编剧", value: "陆云舟、沈南枝" },
  { label: "主演", value: "陈默、江晚、岩川、赵汉声、何丹" },
  { label: "类型", value: "冒险 / 剧情 / 悬疑" },
  { label: "制片地区", value: "中国大陆" },
  { label: "语言", value: "汉语普通话" },
  { label: "上映时间", value: "2024 年 10 月 18 日" },
  { label: "片长", value: "138 分钟" },
];

export const filmCrew = [
  { role: "导演", name: "陆云舟", note: "代表作《雾行者》《北纬之南》" },
  { role: "编剧", name: "陆云舟 / 沈南枝", note: "历时四年打磨剧本" },
  { role: "摄影指导", name: "罗青野", note: "坚持自然光实景拍摄" },
  { role: "剪辑指导", name: "苏芮", note: "以节奏控制情绪张力著称" },
  { role: "原创配乐", name: "顾长风", note: "收录大量雨林原声采样" },
  { role: "美术指导", name: "徐木生", note: "搭建实景营地与村落" },
  { role: "声音设计", name: "何向北", note: "全景声打造沉浸式丛林" },
  { role: "制片人", name: "田知远", note: "长期关注自然题材" },
];

export const synopsis: string[] = [
  "《激情丛林》讲述了植物学家苏雨桐为寻找一份失落三十年的科考档案，独自深入东南亚腹地雨林的故事。她雇佣了当地最熟悉丛林却最不愿提起往事的向导林深，两人带着一份残缺的地图，踏入一片被当地人称为“绿色迷宫”的原始地带。",
  "随着队伍深入，丛林开始显现它真实的面貌：潮湿的空气、无处不在的虫鸣、随时可能吞没一切的暴雨。一桩被掩埋的矿难事故、一个失踪的科考队员、一本写满密码的笔记，让这段寻访逐渐偏离原本的轨道。林深隐瞒多年的秘密，也在这片雨林里一点点浮现。",
  "影片并不满足于讲述一次冒险。当矿业商人赵景行的资本之网延伸到雨林深处，当独立记者何清拼命想揭开真相，每个人都必须在“带走什么”和“留下什么”之间做出选择。《激情丛林》用近乎纪实的笔触，追问人类向自然索取时那份失控的贪婪。",
  "在长达一百三十八分钟的片长里，导演陆云舟几乎没有给出任何轻松的出口。他不提供廉价的胜利，而是让观众和林深一起，在泥泞与暴雨中一步步走完整段旅程——直到最后，才明白那句台词的分量：“丛林从不阻止你进来，它只是决定了谁还能出去。”",
];

export const characters: Character[] = [
  {
    id: "linshen",
    name: "林深",
    actor: "陈默",
    role: "丛林向导",
    avatar:
      "https://readdy.ai/api/search-image?query=Character%20portrait%20of%20a%20stoic%20Asian%20male%20jungle%20guide%20in%20his%20forties%20wearing%20rugged%20field%20gear%20standing%20in%20dense%20dark%20green%20rainforest%20with%20misty%20soft%20warm%20amber%20rim%20light%20cinematic%20moody%20lighting%20professional%20film%20photography%20shallow%20depth%20of%20field%20simple%20blurred%20background%20no%20text&width=600&height=600&seq=jungle-char-1&orientation=squarish",
    bio: "沉默寡言的向导，年轻时曾带过那支失踪的科考队。他熟悉丛林里每一条河与每一处暗流，却始终无法面对自己带回的那段记忆。",
    traits: ["沉默", "经验丰富", "背负秘密"],
  },
  {
    id: "suyutong",
    name: "苏雨桐",
    actor: "江晚",
    role: "植物学家",
    avatar:
      "https://readdy.ai/api/search-image?query=Character%20portrait%20of%20a%20determined%20Asian%20female%20botanist%20in%20her%20thirties%20with%20short%20wet%20hair%20wearing%20a%20field%20vest%20standing%20in%20a%20misty%20dark%20green%20rainforest%20with%20soft%20warm%20amber%20light%20cinematic%20moody%20lighting%20professional%20film%20photography%20simple%20blurred%20background%20no%20text&width=600&height=600&seq=jungle-char-2&orientation=squarish",
    bio: "执拗而清醒的学者。她为了一份迟到的档案走进丛林，却在过程中不断重新理解“求证”与“执念”之间的距离。",
    traits: ["理性", "坚韧", "理想主义"],
  },
  {
    id: "ayan",
    name: "阿岩",
    actor: "岩川",
    role: "丛林猎人",
    avatar:
      "https://readdy.ai/api/search-image?query=Character%20portrait%20of%20an%20elderly%20indigenous%20Asian%20male%20hunter%20with%20weathered%20face%20wearing%20traditional%20woven%20forest%20clothing%20holding%20a%20wooden%20walking%20stick%20in%20misty%20dark%20green%20jungle%20warm%20amber%20backlight%20cinematic%20moody%20lighting%20professional%20film%20photography%20simple%20background%20no%20text&width=600&height=600&seq=jungle-char-3&orientation=squarish",
    bio: "丛林真正的“主人”。他不识几个字，却比任何人都懂得季节、河流与动物的语言，也是唯一一个始终拒绝离开的人。",
    traits: ["通晓自然", "固执", "守护者"],
  },
  {
    id: "zhaojingxing",
    name: "赵景行",
    actor: "赵汉声",
    role: "矿业商人",
    avatar:
      "https://readdy.ai/api/search-image?query=Character%20portrait%20of%20a%20wealthy%20calculating%20Asian%20male%20businessman%20in%20his%20fifties%20wearing%20a%20linen%20shirt%20standing%20against%20a%20blurred%20dark%20green%20rainforest%20backdrop%20with%20soft%20warm%20amber%20light%20cinematic%20moody%20lighting%20professional%20film%20photography%20cold%20neutral%20expression%20no%20text&width=600&height=600&seq=jungle-char-4&orientation=squarish",
    bio: "资本的代表。他相信一切都可以被计算和交易，包括丛林，包括人。他是整段旅程里最体面、也最危险的存在。",
    traits: ["精明", "冷酷", "掌控欲"],
  },
  {
    id: "heqing",
    name: "何清",
    actor: "何丹",
    role: "独立记者",
    avatar:
      "https://readdy.ai/api/search-image?query=Character%20portrait%20of%20a%20young%20tenacious%20Asian%20female%20journalist%20in%20her%20late%20twenties%20with%20a%20camera%20around%20her%20neck%20standing%20in%20misty%20dark%20green%20jungle%20warm%20amber%20rim%20light%20cinematic%20moody%20lighting%20professional%20film%20photography%20simple%20blurred%20background%20no%20text&width=600&height=600&seq=jungle-char-5&orientation=squarish",
    bio: "独自追查矿难真相的记者。她带着相机和执念闯入丛林，是队伍中唯一一个从不掩饰自己目的的人。",
    traits: ["敏锐", "固执", "求真"],
  },
];

export const stills = [
  {
    src: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20small%20exploration%20team%20wading%20through%20a%20shallow%20rainforest%20river%20at%20dawn%20with%20dense%20mist%20deep%20forest%20green%20foliage%20and%20soft%20warm%20amber%20god%20rays%20through%20the%20canopy%20moody%20atmospheric%20film%20still%20professional%20color%20grading%20film%20grain%20no%20text%20no%20watermark&width=1600&height=900&seq=jungle-still-1&orientation=landscape",
    alt: "考察队清晨涉水穿越雨林河流的电影剧照",
    title: "河流远征",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Cinematic%20atmospheric%20shot%20of%20a%20lone%20silhouetted%20figure%20standing%20on%20a%20fallen%20ancient%20tree%20trunk%20deep%20inside%20a%20vast%20misty%20jungle%20with%20dark%20forest%20green%20tones%20and%20faint%20warm%20amber%20backlight%20dramatic%20fog%20professional%20film%20still%20moody%20color%20grading%20no%20text%20no%20watermark&width=1600&height=900&seq=jungle-still-2&orientation=landscape",
    alt: "人物独自站在倒伏巨木上眺望丛林的电影剧照",
    title: "巨木之上",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Macro%20cinematic%20shot%20of%20heavy%20rain%20droplets%20falling%20on%20large%20deep%20green%20tropical%20leaves%20in%20a%20dark%20moody%20forest%20with%20soft%20warm%20amber%20highlights%20atmospheric%20haze%20shallow%20depth%20of%20field%20professional%20film%20still%20color%20grading%20film%20grain%20no%20text%20no%20watermark&width=1600&height=900&seq=jungle-still-3&orientation=landscape",
    alt: "大雨打落在热带阔叶上的特写剧照",
    title: "暴雨将至",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Cinematic%20night%20shot%20of%20a%20small%20expedition%20campsite%20with%20warm%20amber%20lantern%20light%20glowing%20inside%20a%20dark%20dense%20jungle%20surrounded%20by%20mist%20and%20deep%20forest%20green%20foliage%20moody%20atmospheric%20professional%20film%20still%20color%20grading%20no%20text%20no%20watermark&width=1600&height=900&seq=jungle-still-4&orientation=landscape",
    alt: "夜间营地暖黄灯光被丛林包围的电影剧照",
    title: "营地之夜",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20ancient%20moss%20covered%20stone%20ruins%20hidden%20deep%20within%20a%20foggy%20tropical%20jungle%20with%20dark%20forest%20green%20tones%20creeping%20vines%20and%20soft%20warm%20amber%20light%20breaking%20through%20mist%20professional%20film%20still%20moody%20color%20grading%20no%20text%20no%20watermark&width=1600&height=900&seq=jungle-still-5&orientation=landscape",
    alt: "被苔藓覆盖的丛林遗迹电影剧照",
    title: "失落的遗迹",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Cinematic%20aerial%20drone%20shot%20of%20an%20endless%20canopy%20of%20a%20misty%20rainforest%20at%20dusk%20with%20deep%20forest%20green%20tones%20low%20hanging%20fog%20and%20a%20thin%20river%20cutting%20through%20warm%20amber%20sunset%20haze%20professional%20film%20still%20moody%20color%20grading%20no%20text%20no%20watermark&width=1600&height=900&seq=jungle-still-6&orientation=landscape",
    alt: "黄昏时分航拍的无边丛林树冠电影剧照",
    title: "无尽树冠",
  },
];

export const posterImage =
  "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20visual%20of%20a%20lone%20silhouetted%20adventurer%20walking%20through%20a%20dense%20misty%20jungle%20with%20deep%20forest%20green%20foliage%20towering%20trees%20and%20warm%20amber%20god%20rays%20piercing%20the%20canopy%20dramatic%20mysterious%20atmosphere%20professional%20color%20grading%20film%20grain%20simple%20clean%20composition%20no%20text%20no%20watermark&width=600&height=900&seq=jungle-poster-main&orientation=portrait";

export const heroSlides = [
  {
    id: "slide-1",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20dark%20misty%20jungle%20canopy%20with%20towering%20trees%20deep%20forest%20green%20tones%20warm%20amber%20light%20rays%20breaking%20through%20thick%20fog%20moody%20atmospheric%20artistic%20painterly%20illustration%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1920&height=1080&seq=jungle-hero-1&orientation=landscape",
    tag: "深度剧情解析",
    title: "在失控的绿色迷宫里，重新定义冒险片的呼吸感",
    desc: "从疏林到密林，从求索到自省。《激情丛林》用一场没有退路的远征，讲述欲望与敬畏之间的漫长对峙。",
    link: "/plot",
    cta: "阅读剧情全解",
  },
  {
    id: "slide-2",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20rainforest%20river%20at%20dusk%20with%20dark%20forest%20green%20water%20reflections%20low%20hanging%20mist%20warm%20amber%20sunset%20glow%20along%20the%20horizon%20artistic%20painterly%20illustration%20moody%20atmospheric%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1920&height=1080&seq=jungle-hero-2&orientation=landscape",
    tag: "专业影评精选",
    title: "当丛林成为主角：论《激情丛林》的空间叙事",
    desc: "影片真正的主角或许不是任何一个人，而是那片会呼吸、会沉默、也会反噬的雨林。",
    link: "/reviews",
    cta: "查看影评合集",
  },
  {
    id: "slide-3",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20silhouette%20of%20a%20solitary%20figure%20standing%20amid%20dense%20dark%20green%20jungle%20with%20warm%20amber%20light%20rays%20and%20heavy%20fog%20artistic%20painterly%20illustration%20dramatic%20mysterious%20atmosphere%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1920&height=1080&seq=jungle-hero-3&orientation=landscape",
    tag: "最新资讯",
    title: "密钥延期放映至年底，幕后纪录片同步上线",
    desc: "关于《激情丛林》的一切仍在继续：新曝光的幕后花絮、主创访谈与雨林守护特别放映。",
    link: "/news",
    cta: "浏览最新动态",
  },
];